import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { Project } from '../../models/project';
import { ProjectService } from '../../services/project.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MathCalculatorComponent } from '../math-calculator/math-calculator.component';
import { Role } from '../../models/user-role';
import { RoleService } from '../../services/user-role.service';
import { GlobalVariable } from '../../helpers/settings';
import { Subscription } from '../../models/subscription';

SwiperCore.use([Navigation, Pagination, Autoplay]);
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	public elem: any;
	public currentUser?: Partial<User>;
	public iconSetting: string = 'settings';
	public emailVerified?: boolean = true;
	public selectedProject: Project = null;
	public hasAccessToPOS = false;

	private ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		centered: true
	};

	constructor(
		public layout: LayoutService,
		private router: Router,
		private projectService: ProjectService,
		public navServices: NavService,
		public userService: UserService,
		private modalService: NgbModal,
		private roleService: RoleService,
		@Inject(DOCUMENT) private document: any
	) {}

	ngOnInit() {
		this.elem = document.documentElement;
		this.currentUser = this.userService.getCurrentUser();
		if (this.currentUser?._id) {
			this.emailVerified = this.currentUser?.emailVerified;
		}
		this.selectedProject = this.projectService.getCurrentProject();
		if (this.selectedProject?._id) {
			this.projectService
				.findById(this.selectedProject?._id, false, false, null, null, 'sidebar', 'find projects')
				.subscribe(res => {
					this.selectedProject = res;
					this.projectService.setCurrentProject(this.selectedProject, false);
					this.hasAccessToPOS = this.veryfyAccess(
						this.selectedProject._id,
						GlobalVariable['ORDERS_MANAGEMENT'].route,
						'add'
					);
				});
		} else {
			this.projectService.deleteCurrentProject();
		}
	}

	public openMathCalculator() {
		const modalRef = this.modalService.open(MathCalculatorComponent, { ...this.ngbModalOptions, size: 'md' });
		modalRef.result.then(result => {});
	}
	veryfyAccess(projectId, applicationRoute, action = null) {
		const user = this.userService.getCurrentUser();
		const hasOwnerRole = user?.roles?.includes('Owner');
		const currentSubscription = user.subscription as Subscription;
		const appCOde = this.roleService.toUpperCaseWithUnderscores(applicationRoute);
		const authorisation =
			this.roleService.getApplicationAuthorization(applicationRoute, currentSubscription) &&
			this.selectedProject.applications.includes(appCOde);
		if (authorisation) {
			if (hasOwnerRole) return true;
			if (user?.roles?.includes('User')) {
				const currentUserRole: Role = user?.userRole?.role as Role;
				return this.roleService.getAuthorizationProjectComponent(
					currentUserRole,
					projectId,
					applicationRoute,
					action
				);
			}
		} else {
			return false;
		}
	}
	sidebarToggle() {
		this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
		this.navServices.megaMenu = false;
		this.navServices.levelMenu = false;
	}

	layoutToggle() {
		if ((this.layout.config.settings.layout_version = 'dark-only')) {
			document.body.classList.toggle('dark-only');
		}
		document.body.remove;
	}

	searchToggle() {
		this.navServices.search = true;
	}

	languageToggle() {
		this.navServices.language = !this.navServices.language;
	}

	toggleFullScreen() {
		this.navServices.fullScreen = !this.navServices.fullScreen;
		if (this.navServices.fullScreen) {
			if (this.elem.requestFullscreen) {
				this.elem.requestFullscreen();
			} else if (this.elem.mozRequestFullScreen) {
				/* Firefox */
				this.elem.mozRequestFullScreen();
			} else if (this.elem.webkitRequestFullscreen) {
				/* Chrome, Safari and Opera */
				this.elem.webkitRequestFullscreen();
			} else if (this.elem.msRequestFullscreen) {
				/* IE/Edge */
				this.elem.msRequestFullscreen();
			}
		} else {
			if (!this.document.exitFullscreen) {
				this.document.exitFullscreen();
			} else if (this.document.mozCancelFullScreen) {
				/* Firefox */
				this.document.mozCancelFullScreen();
			} else if (this.document.webkitExitFullscreen) {
				/* Chrome, Safari and Opera */
				this.document.webkitExitFullscreen();
			} else if (this.document.msExitFullscreen) {
				/* IE/Edge */
				this.document.msExitFullscreen();
			}
		}
	}
}
